export default __webpack_public_path__ + "static/media/guide_dev_01.a4fbd6dc.md";